// extracted by css-extract-rspack-plugin
export default {"shareIcon":"SharePropertyWrapper-module__shareIcon","elevatedZIndex":"SharePropertyWrapper-module__elevatedZIndex"};